"use strict";
/**
 * Ruta Privada
 * Ruta: PrivateRoute.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu
 * Versió: 1.0
 * Data: 24/08/2017
 * (c) Ajuntament de Manresa - ago 2017 - Departament de Sistemes d'Informació
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_router_dom_1 = require("react-router-dom");

var react_router_1 = require("react-router");

var PrivateRoute = function PrivateRoute(_a) {
  var isLogged = _a.isLogged,
      tePermis = _a.tePermis,
      permisMinim = _a.permisMinim,
      Component = _a.component,
      rest = __rest(_a, ["isLogged", "tePermis", "permisMinim", "component"]);

  return React.createElement(react_router_dom_1.Route, __assign({}, rest, {
    render: function render(props) {
      return isLogged && tePermis ? Component ? React.createElement(Component, __assign({}, props)) : null : React.createElement(react_router_1.Redirect, {
        to: {
          pathname: '/login',
          state: {
            from: props.location,
            permisMinim: permisMinim
          }
        }
      });
    }
  }));
};

exports.default = PrivateRoute;